<template>
  <div
    style="display: flex;align-items: center;justify-content: center;font-size: 16px"
  >
    您无权访问本页面，如需访问请联系新华财经获取相应权限！
  </div>
</template>

<script>
export default {
  name: "NoAuth"
};
</script>

<style scoped></style>
